import {
  Box,
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useRef, useState } from "react";
import * as XLSX from "xlsx";
import ExcelUploader from "./ExcelUploader";
import { useMutation, useQueryClient } from "react-query";
import { GetChequeForShowInProsses } from "../../services/chequeProsses.service";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  Cheques,
  ChequesResponse,
  GetChequesRequest,
} from "../../models/chequeProsses.model";

import { createStyles, makeStyles } from "@material-ui/core";
import { TABLE_FILTER_CHEQUE } from "../../config/cacheKey";
import { PaginationInfo } from "../../models/cartable.model";
import { toast } from "react-toastify";
const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};
const columns: readonly ColumnModel[] = [
  {
    id: "sayadNumber",
    label: "شماره صیاد",
  },
  {
    id: "receiveBankAccountNumber",
    label: "شماره حساب",
  },
  {
    id: "yourState",
    label: "وضعیت درخواستی",
  },
  {
    id: "date",
    label: "تاریخ چک",
  },

  {
    id: "deedNumber",
    label: "شماره سند",
  },
  {
    id: "deedDate",
    label: "تاریخ سند",
  },
  {
    id: "deedEffectiveDate",
    label: "تاریخ موثر سند",
  },
  {
    id: "chequeDueDate",
    label: "تاریخ سررسید",
  },
  {
    id: "amount",
    label: "مبلغ چک",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },

  {
    id: "stateTitle",
    label: "وضعیت چک",
  },
  {
    id: "processDate",
    label: "تاریخ پردازش",
  },
  {
    id: "isProcessed",
    label: "پردازش شده در اقساط",
  },
  {
    id: "modifyDate",
    label: "تاریخ اخرین تغییر",
  },
  {
    id: "isExsit",
    label: "یافت شد/نشد",
  },
];
export type ButtonStatus = "showProcess" | "showExportExcel" | "other";

const ChequeProsses = () => {
  const queryClient = useQueryClient();
  const [data, setData] = useState<Cheques[]>();
  const [dataResponse, setDataResponse] = useState<ChequesResponse[]>();
  const [buttonStatus, setButtonStatus] = useState<ButtonStatus>("other");
  let muiSelected: any;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const inputRef = useRef<any>(null);
  const handleFileUpload = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const workbook = XLSX.read(event.target?.result, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData: Cheques[] = XLSX.utils.sheet_to_json(sheet);

      let checkKeyPresenceInArray = (key: string) =>
        sheetData.some((obj) => Object.keys(obj).includes(key));
      const checkData =
        checkKeyPresenceInArray("sayadNumber") &&
        checkKeyPresenceInArray("ReceiveBankAccountNumber") &&
        checkKeyPresenceInArray("state") &&
        checkKeyPresenceInArray("date");

      if (checkData) {
        queryClient.setQueryData<Cheques[]>(TABLE_FILTER_CHEQUE, sheetData);
        fillData(sheetData);
      } else {
        toast.error("فرمت فایل صحیح نمیباشد");
      }
    };

    reader.readAsBinaryString(file);
  };
  const generateFilter = (filterData: Cheques[]): GetChequesRequest => {
    let due = {} as GetChequesRequest;

    due.paginationInfo = currentPaginationInfo;
    due.filter = filterData;
    return due;
  };
  const fillData = (filterData: Cheques[]) => {
    let filter = generateFilter(filterData);
    GetExcelDataMutate.mutate(filter);
    setData(filterData);
  };
  const GetExcelDataMutate = useMutation(GetChequeForShowInProsses, {
    onSuccess: (data: ApiResultModel<ChequesResponse[]>) => {
      if (data) {
        setDataResponse(data.data);
        let pageInfoModel = new PageInfoModel();
        pageInfoModel.pageNumber = 1;
        pageInfoModel.pageSize = 10;
        pageInfoModel.total = 0;
        setPageInfo(data.pageInfo !== null ? data.pageInfo : pageInfoModel);
        setButtonStatus("showProcess");
      }
    },
    onError: () => {},
  });

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };
  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Cheques[]>(
      TABLE_FILTER_CHEQUE
    );
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };
  function getSecondPart(str: string, i: number) {
    return str.split("/")[i];
  }
  return (
    <>
      <Box
        width={"100%"}
        height={{
          sm: "100vh",
          xs: "100vh",
          md: "85vh",
          lg: "85vh",
          xl: "85vh",
        }}
        // border={"1.5px solid #DAE0E4"}
        // borderRadius={"5px"}
        // padding={"2rem"}
      >
        <Box sx={{ marginTop: "1rem" }}>
          <ExcelUploader
            inputRef={inputRef}
            data={data!}
            setButtonStatus={setButtonStatus}
            buttonStatus={buttonStatus}
          />
          <input
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            style={{ display: "none" }}
            ref={inputRef}
            type="file"
            onChange={handleFileUpload}
          />
        </Box>

        <div>
          <div className="cardTableBorder">
            <TableContainer
              style={{ background: "#fff", maxHeight: "55vh" }}
              className="boxScroll"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                      align="right"
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      #
                    </TableCell>
                    {columns.map(
                      (column) => (
                        // column.id === "isExsit" ? (
                        //   <TableCell
                        //     className="rowTHead colorTitle textFont12 fontWeight noWrap"
                        //     key={column.id}
                        //     align="right"
                        //   >
                        //     {`${getSecondPart(column.label!, 0)} (${
                        //       dataResponse
                        //         ? dataResponse?.filter((i) => i.isExsit).length
                        //         : 0
                        //     })
                        //       /
                        //       ${getSecondPart(column.label!, 1)} (${
                        //       dataResponse
                        //         ? dataResponse?.filter((i) => !i.isExsit).length
                        //         : 0
                        //     })
                        //       `}
                        //   </TableCell>
                        // ) : (
                        <TableCell
                          className="rowTHead colorTitle textFont12 fontWeight noWrap"
                          key={column.id}
                          align="right"
                        >
                          {column.label}
                        </TableCell>
                      )
                      // )
                    )}
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>
                <TableBody>
                  {dataResponse
                    ? dataResponse?.map((row, rowIndex) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft cursorPointer noWrap`}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={rowIndex}
                            onClick={() => {}}
                          >
                            <TableCell
                              className="textFont12 WidthRowNumber"
                              style={{ width: "10vh", minWidth: "10vh" }}
                            >
                              {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                                (currentPaginationInfo.pageSize! ?? 0) +
                                rowIndex +
                                1}
                            </TableCell>
                            {columns.map((column) => {
                              const value =
                                row[column.id as keyof ChequesResponse];
                              return (
                                <>
                                  {column.id !== "isExsit" ? (
                                    <>
                                      {column.id !== "isProcessed" ? (
                                        <TableCell
                                          className="textFont12"
                                          key={column.id}
                                          align="right"
                                        >
                                          {column.format && column.hasFormat
                                            ? column.format(value)
                                            : value?.toString()}
                                        </TableCell>
                                      ) : (
                                        <TableCell>
                                          {value ? (
                                            <span style={{ color: "#E6123D" }}>
                                              پردازش شده
                                            </span>
                                          ) : (
                                            <>
                                              {value === null ? (
                                                <span
                                                  style={{ color: "#01AF43" }}
                                                ></span>
                                              ) : (
                                                <span
                                                  style={{ color: "#01AF43" }}
                                                >
                                                  پردازش نشده
                                                </span>
                                              )}
                                            </>
                                          )}
                                        </TableCell>
                                      )}
                                    </>
                                  ) : (
                                    <TableCell>
                                      {value ? (
                                        <>
                                          <span style={{ color: "#01AF43" }}>
                                            یافت شد
                                          </span>
                                        </>
                                      ) : (
                                        <span style={{ color: "#E6123D" }}>
                                          یافت نشد
                                        </span>
                                      )}
                                    </TableCell>
                                  )}
                                </>
                              );
                            })}
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div>
            <div className="row"></div>
            <Grid container xs={12}>
              <Grid item xs={4}>
                <span
                  style={{
                    color: "#1D4A87",
                    top: "1vh",
                    position: "relative",
                  }}
                >
                  تعداد کل :
                  <span style={{ color: "#01AF43" }}>{pageInfo.total}</span>{" "}
                  مورد
                </span>
              </Grid>
              <Grid item xs={4}>
                <Pagination
                  renderItem={(item) => (
                    <PaginationItem
                      components={{
                        previous: previusIcon,
                        next: nextIcon,
                      }}
                      {...item}
                    />
                  )}
                  // color="primary"
                  sx={{
                    display: "flex",
                    justifyContent: "center !important",
                    direction: "ltr",
                    margin: "5px",
                    button: {
                      color: "#25D1C9",
                      fontSize: "14px !important",
                      fontFamily: "iranSans",
                    },
                    //  button.sele
                  }}
                  count={
                    pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                  }
                  onChange={handleChangePagination}
                  page={currentPaginationInfo.pageNumber}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </div>
        </div>
      </Box>
    </>
  );
};

export default ChequeProsses;
